import React from 'react';

import Button from '../../UI/Button/Button';
import FlexModal from '../../UI/FlexModal/FlexModal';

import classes from './LiveSessionPopup.module.css';

import closeIconBlack from '../../../assets/icons/icon-close-black.png';
import RouteEndPoints from '../../../utilities/RouteEndPoints';
import { Link } from 'react-router-dom';
import { GetFromLocalStorage, IsListEmpty, IsObjectEmpty, IsStringEmpty } from '../../../utilities/CommonMethods';
import ResourceAPIController from '../../../webServices/ResourceAPIController';
import ShowLoader from '../../../hoc/ShowLoader/ShowLoader';
import Constants from '../../../utilities/Constants';
import axios from 'axios';

class LiveSessionPopup extends React.Component {

    state = {
        liveSessionData: {},
        showPopupLoader: true,
        showErrorMessage: false,
        errorMessage: '',
        attendanceCallInProgress: false
    }

    getLiveSessionDetails = (liveSessionId) => {
        ResourceAPIController.getLearnerLiveSessionData(liveSessionId)
            .then(response => {
                // console.log('getLearnerLiveSessionData Popup Data => ', response.result)
                const liveSessionData = {
                    meetingId: response.result.meetingNumber,
                    encPassword: response.result.encPassword
                }
                this.setState({ liveSessionData: liveSessionData, showPopupLoader: false, showErrorMessage: false })
            })
            .catch(err => {
                console.log('getLearnerLiveSessionData Popup error => ', err, err.error.message)
                this.setState({ showPopupLoader: false, showErrorMessage: true, errorMessage: err.error.message });
            });
    }

    onMouseDown = (event) => {
        if (event.button === 2 && this.state.attendanceCallInProgress === false) {
            this.markStudentAttendance(false, 'onLinkRightClick');
        }
    }

    onCopy = () => {
        if (this.state.attendanceCallInProgress === false) {
            this.markStudentAttendance(false, 'onLinkCopy');
        }
    }

    markStudentAttendance = (closePopup, source) => {
        this.setState({ attendanceCallInProgress: true });
        this.logDataOnFirebase(source, 'Initiated');
        let data = {
            "has_watched_recording": false,
            "watched_date_time": new Date().toISOString()
        };

        ResourceAPIController.markStudentAttendance(this.props.liveSessionId, data)
            .then(response => {
                // console.log('markStudentAttendance Popup Data => ', response.result)
                this.setState({ attendanceCallInProgress: false });
                this.logDataOnFirebase(source, 'Success');
                if (closePopup) {
                    this.props.closeButtonClick();
                }
            })
            .catch(err => {
                this.setState({ attendanceCallInProgress: false });
                this.logDataOnFirebase(source, 'Failed', err.error);
                console.log('markStudent Popup error => ', err)
            });
    }

    deviceType = () => {
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return "Tablet";
        }
        else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
            return "Mobile";
        }
        return "Desktop";
    };

    logDataOnFirebase = (source, status, err) => {
        // console.log('source => ', source, status);
        // const email = GetFromLocalStorage(Constants.KEY_EMAIL), username = GetFromLocalStorage(Constants.KEY_USERNAME);
        // let data = {
        //     username: username,
        //     email: email,
        //     dateTime: new Date(),
        //     source: source,
        //     status: status,
        //     liveSessionData: !IsObjectEmpty(this.props.data) && !IsListEmpty(this.props.data.currentSessionData) ? this.props.data.currentSessionData[0] : null,
        //     currentTopicDetails: !IsObjectEmpty(this.props.data) && !IsObjectEmpty(this.props.data.currentTopicDetails) ? this.props.data.currentTopicDetails : null,
        //     deviceWidth: document.documentElement.clientWidth,
        //     deviceHeight: document.documentElement.clientHeight,
        //     deviceType: this.deviceType(),
        //     userAgent: navigator.userAgent,
        //     pageURL: window.location.pathname,
        //     error: err
        // }
        // axios.post('https://university-application-trackin-default-rtdb.firebaseio.com/attendance-tracking.json', data);
    }

    componentDidMount() {
        if (IsObjectEmpty(this.props.liveSessionData)) {
            this.getLiveSessionDetails(this.props.liveSessionId);
        } else {
            this.setState({ liveSessionData: this.props.liveSessionData, showPopupLoader: false, showErrorMessage: false });
        }
    }

    render() {
        return (
            <FlexModal visible={this.props.show}>
                <div className={classes.LiveSessionPopup}>
                    <img
                        className={classes.CloseIcon}
                        src={closeIconBlack}
                        alt="Close Icon"
                        onClick={this.state.attendanceCallInProgress ? null : this.props.closeButtonClick}
                    />

                    {
                        this.state.showPopupLoader
                            ? <div className={classes.LoaderContainer}>
                                <ShowLoader isLoading={true} transparentBg={true} />
                            </div>
                            : <>
                                <h3 className={classes.Heading}>Join LIVE Session</h3>
                                <p className={classes.SessionDate}>
                                    {!IsObjectEmpty(this.props.data) ? this.props.data.date : ''}
                                </p>

                                <p className={classes.MessageText}>Today's session has started.</p>

                                <div className={classes.ButtonContainer}>
                                    <Link to={RouteEndPoints.LIVE_SESSION_PAGE + '/?sessionId=' + this.props.liveSessionId} target="_blank" className={classes.RemoveTextDecoration}>
                                        <Button
                                            styleclass={"NonMobileOnly"}
                                            label="JOIN NOW"
                                            clicked={() => this.markStudentAttendance(true, 'onButtonClick')}
                                            margin="0px 0px 1em 0px "
                                            padding="8px 48px"
                                        />
                                    </Link>
                                    {/* <a href={`https://zekelabs.zoom.us/j/${this.state.liveSessionData.meetingId}?pwd=${this.state.liveSessionData.encPassword}`} target="_blank" className={classes.RemoveTextDecoration}>
                                        <Button
                                            styleclass={"NonMobileOnly"}
                                            label="JOIN NOW"
                                            clicked={() => this.markStudentAttendance(true, 'onButtonClick')}
                                            margin="0px 0px 1em 0px "
                                            padding="8px 48px"
                                        />
                                    </a> */}
                                </div>

                                {/* <p className={classes.OrText}>OR</p>

                                <p className={classes.LinkText} onClick={this.markStudentAttendance}>
                                    <a href={`https://zekelabs.zoom.us/j/${this.state.liveSessionData.meetingId}?pwd=${this.state.liveSessionData.encPassword}`} target="_blank" className={classes.RemoveTextDecoration}>
                                        {`https://zekelabs.zoom.us/j/${this.state.liveSessionData.meetingId}?pwd=${this.state.liveSessionData.encPassword}`}
                                    </a>
                                </p> */}
                                {
                                    this.state.showErrorMessage
                                        ? <p className={classes.ErrorMessage}>
                                            {!IsStringEmpty(this.state.errorMessage)
                                                ? this.state.errorMessage : 'Something went wrong'}
                                        </p>
                                        : <>
                                            <p className={classes.OrText}>OR</p>
                                            <p className={classes.LinkText} onMouseDown={this.onMouseDown} onCopy={this.onCopy} onClick={() => this.markStudentAttendance(false, 'onLinkLeftClick')}>
                                                <a href={`https://zekelabs.zoom.us/j/${this.state.liveSessionData.meetingId}?pwd=${this.state.liveSessionData.encPassword}`} target="_blank" className={classes.RemoveTextDecoration}>
                                                    {`https://zekelabs.zoom.us/j/${this.state.liveSessionData.meetingId}?pwd=${this.state.liveSessionData.encPassword}`}
                                                </a>
                                            </p>
                                        </>
                                }
                            </>
                    }
                </div>
            </FlexModal>
        )
    }
}

export default LiveSessionPopup;